import styled from 'styled-components';

export const StyledModalName = styled.div`
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[6]};
  box-shadow: ${(p) => p.theme.shadows.bottom};
  font-weight: 500;
`;
